import { render } from "./SharedLayout.vue?vue&type=template&id=08eba009&scoped=true"
import script from "./SharedLayout.vue?vue&type=script&lang=js"
export * from "./SharedLayout.vue?vue&type=script&lang=js"

import "./SharedLayout.vue?vue&type=style&index=0&id=08eba009&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08eba009"]])

export default __exports__